(() => {
  if (window.AlawooderHotspots) {
    window.AlawooderHotspots.init(document);
    return;
  }

  const controllers = new Map();
  const mobile = window.matchMedia('(max-width: 820px)');
  let activeController = null;

  function mount(root) {
    if (controllers.has(root)) return;
    const triggers = Array.from(root.querySelectorAll('[data-room-hotspot-trigger]'));
    const panels = Array.from(root.querySelectorAll('[data-room-hotspot-panel]'));
    const stage = root.querySelector('[data-room-hotspot-stage]');
    let selected = null;
    let frame = 0;

    function position() {
      if (!selected || mobile.matches || !stage) return;
      const panel = document.getElementById(selected.getAttribute('aria-controls'));
      if (!panel || panel.hidden) return;
      const stageBox = stage.getBoundingClientRect();
      const pointBox = selected.getBoundingClientRect();
      const panelBox = panel.getBoundingClientRect();
      const pointX = pointBox.left - stageBox.left + pointBox.width / 2;
      const pointY = pointBox.top - stageBox.top + pointBox.height / 2;
      const gap = 29;
      let left = pointX - panelBox.width - gap;
      if (left < 16) left = pointX + gap;
      left = Math.max(16, Math.min(left, stageBox.width - panelBox.width - 16));
      const top = Math.max(16, Math.min(pointY - panelBox.height / 2, stageBox.height - panelBox.height - 16));
      panel.style.left = `${Math.round(left)}px`;
      panel.style.top = `${Math.round(top)}px`;
    }

    function schedulePosition() {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(position);
    }

    function close(restoreFocus = false) {
      const previous = selected;
      triggers.forEach(trigger => trigger.setAttribute('aria-expanded', 'false'));
      panels.forEach(panel => { panel.hidden = true; });
      selected = null;
      root.classList.remove('has-open-detail');
      if (activeController === controller) activeController = null;
      if (restoreFocus && previous && previous.isConnected) previous.focus({ preventScroll: true });
    }

    function open(trigger) {
      const panel = document.getElementById(trigger.getAttribute('aria-controls'));
      if (!panel || !root.contains(panel)) return;
      if (activeController && activeController !== controller) activeController.close();
      close();
      selected = trigger;
      activeController = controller;
      trigger.setAttribute('aria-expanded', 'true');
      panel.hidden = false;
      root.classList.add('has-open-detail');
      position();
    }

    function onClick(event) {
      const trigger = event.target.closest('[data-room-hotspot-trigger]');
      if (trigger && root.contains(trigger)) {
        if (selected === trigger) close();
        else open(trigger);
        return;
      }
      if (event.target.closest('[data-room-hotspot-close]')) close(true);
    }

    function onOutside(event) {
      if (!selected) return;
      const panel = document.getElementById(selected.getAttribute('aria-controls'));
      if (selected.contains(event.target) || (panel && panel.contains(event.target))) return;
      close();
    }

    function onKey(event) {
      if (event.key === 'Escape' && selected) {
        event.preventDefault();
        close(true);
      }
    }

    const observer = new ResizeObserver(schedulePosition);
    observer.observe(root);
    root.addEventListener('click', onClick);
    root.addEventListener('load', schedulePosition, true);
    document.addEventListener('click', onOutside);
    document.addEventListener('keydown', onKey);
    const controller = {
      root,
      open,
      close,
      triggers,
      destroy() {
        close();
        cancelAnimationFrame(frame);
        observer.disconnect();
        root.removeEventListener('click', onClick);
        root.removeEventListener('load', schedulePosition, true);
        document.removeEventListener('click', onOutside);
        document.removeEventListener('keydown', onKey);
        controllers.delete(root);
      }
    };
    controllers.set(root, controller);
  }

  function init(scope) {
    if (scope.matches && scope.matches('[data-room-hotspots]')) mount(scope);
    scope.querySelectorAll('[data-room-hotspots]').forEach(mount);
  }

  function destroy(scope) {
    controllers.forEach(controller => {
      if (scope === controller.root || scope.contains(controller.root)) controller.destroy();
    });
  }

  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => destroy(event.target));
  document.addEventListener('shopify:block:select', event => {
    const blockId = String(event.detail?.blockId || '');
    controllers.forEach(controller => {
      const trigger = controller.triggers.find(button => button.dataset.roomHotspotTrigger === blockId);
      if (trigger) controller.open(trigger);
    });
  });
  document.addEventListener('shopify:block:deselect', event => {
    const blockId = String(event.detail?.blockId || '');
    if (activeController && activeController.triggers.some(button => button.dataset.roomHotspotTrigger === blockId)) activeController.close();
  });
  mobile.addEventListener('change', () => {
    if (activeController) {
      const trigger = activeController.triggers.find(button => button.getAttribute('aria-expanded') === 'true');
      if (trigger) activeController.open(trigger);
    }
  });
  window.AlawooderHotspots = { init, destroy };
  init(document);
})();
